import { AfterViewInit, Component, OnInit } from '@angular/core';
import { NgFlowchartStepComponent } from '../../../../../../projects/ng-flowchart/src/lib/ng-flowchart-step/ng-flowchart-step.component';
import { ConfirmationDialogService } from '../../confirmation-dialog.service';
import { ToastrService } from 'ngx-toastr';
import { NgFlowchart } from 'projects/ng-flowchart/src/lib/model/flow.model';
import { TestService } from '../../../../_services/test.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { DropDataService } from '../../../../../../projects/ng-flowchart/src/lib/services/dropdata.service';
import { Subscription } from 'rxjs';
import { ProjectService } from '../../../../_services/project.service';

export type MyForm = {
  input1: string;
};

@Component({
  selector: 'app-form-step1',
  templateUrl: './form-step1.component.html',
  styleUrls: ['./form-step1.component.scss'],
})
export class FormStep1Component 
  extends NgFlowchartStepComponent<MyForm>
  implements OnInit , AfterViewInit
{
  stepOptions: any;
  checkAllTestSteps: boolean;
  testStep: any;
  testStepCopy: any=[];
  projectType: string;
  testCaseType: string;
  testStepdata: any;
  testCopyFlowChart: any;
  // testCase: any;
  visibleIndexForCardTip: any;
  projectId: any;
  testId: any;
  testStepId: any;
  testStepAtSelectedIndex: { active: string; commandName: string; comment: string; runtimeData: string; debug: string; elementKey: string; evaluatedMetaValue: string; maskedData: string; pageName: string; parameters: { settingValue: string; isMasked: string; }; result: { startTime: string; endTime: string; duration: string; resultState: {}; aggrResultState: {}; }; runState: string; testData: string; type: string; };
  url: string;
  initiateDelTestStep: any;
  stepsTobeDelete: any;
  enableCutPaste: boolean
  enableCopyPaste: any;
  selectedIndex: any;
  showIndex: boolean = false;
  actionsMetaData: any={};
  groupedActionData: any;
  selectedSteps: any;
  currentStepSelected : boolean = false;
  subscription: Subscription;
  subscription1: Subscription;
  subscription2: Subscription;
  subscription3: Subscription;
  actions: any;
  functions: any;
  currentRcSteps: any;
  rcCat: string | null;
  rcId: string | null;
  headerOptions: any;
  homeService: any;
  rcDetails: any;
  constructor( 
    private confirmationDialogService: ConfirmationDialogService,
    private toastrService: ToastrService,
    private testService: TestService,
    private route: ActivatedRoute,
    private http: HttpClient,
    private dropDataService: DropDataService,
    private project: ProjectService,
    private router:Router,
  ) {
    
    super();
    this.url = environment.baseUrl;
  }

  override ngOnInit(): void {
if(!JSON.parse(localStorage.getItem('groupedActionData'))){
  this.testService.getGroupedAction().subscribe(
    (data) => {
      this.groupedActionData = data;
      localStorage.setItem('groupedActionData', JSON.stringify(this.groupedActionData))
      console.log(this.groupedActionData);
      this.loadActionsMetaData();
    }
    )
}
else{
  this.groupedActionData = JSON.parse(localStorage.getItem('groupedActionData'));
  this.loadActionsMetaData();
}

    this.currentStepSelected = this.data['checked'];
   this.subscription =  this.testService.getCutEnable().subscribe((data)=>{
      this.enableCutPaste = data
    });

   this.subscription1 =  this.testService.getCopyEnable().subscribe(
      (data)=>{
        this.enableCopyPaste = data
      }
    );
    this.subscription2 = this.testService.getSelectedData().subscribe((res)=>
      {
        this.selectedSteps = res;
    });
    
    if(this.data['name']){
      this.data['commandName'] = this.data['name']
    }
    if(this.data['stepComment']){
      this.data['comment'] = this.data['stepComment']
    }
    this.dropDataService.selectAllSteps.subscribe((res)=>
      {
        this.data['checked'] = res;
        this.currentStepSelected = res;
      })
    
    this.route.paramMap.subscribe(
      params => {
        this.projectId = params.get('pid');
        this.testId = params.get('tid');
        this.testStepId = params.get('tsid')
        var res = JSON.parse(localStorage.getItem('projectDataById'));
        if(this.projectId=='rc'){
          this.rcCat = params.get('tid');
           this.rcId = params.get('tsid');
           this.headerOptions.showSetting = false;
        //    this.headerOptions.heading ='Reusable Component',
        //    this.headerOptions.data = {
        //   projectId: undefined,
        //   projectName: this.rcCat
        // };
          //  this.getRC();
           console.log(this.rcCategoryList);
          //  this.homeService.setHeaderOptions(this.headerOptions);
         }

        // this.projectData = res;
        // this.headerOptions.data = {
        //   projectId: this.projectId,
        //   projectName: res['projectName']
        // };
        // this.inItFlowChart();
        // this.getFunction();
        // this.getBranches(this.projectId,this.testId);
      })
      if(this.canvas.flow.rootStep)
      {
        this.showIndex = this.canvas.flow.rootStep.type == 'form-step' ?  false : true;
      }
      else
      {
        this.showIndex =  true;
      }
    
    setTimeout(() => {
   
    if(this.canvas.currentDropTarget){
    if(this.canvas.currentDropTarget && this.canvas.currentDropTarget.position=='BELOW' || this.canvas.currentDropTarget && this.canvas.currentDropTarget.position=='ABOVE'){
        
        if(this.canvas.currentDropTarget.step.data.branch==true){
          console.log(this.canvas.currentDropTarget.step.data.branch );
          this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testCaseData/' + this.projectId + '/' + this.testId + '/' + this.canvas.currentDropTarget.step.data.id).
          subscribe(
            (data) => {

              this.testStepdata = data;
              this.testStep = this.testStepdata.teststepList;
              if(this.data['commandName']=='INVOKETEST'){
                this.toastrService.clear();
                this.toastrService.warning('Can not add Invoke command under HITL');
                this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testCaseData/' + this.projectId + '/' + this.testId + '/' + this.testStepId).
                subscribe(
                  (data) => {
                    this.testStepdata = data;
                    this.testStep = [];
                    this.testStep = this.testStepdata.teststepList;
                    for (let i = 0; i < this.testStep.length; i++) {
                      // this.testStep[i] = {
                      //    stepIndex:''
                      //   }
                      this.testStep[i].stepIndex = i;
                      this.testStep[i].viewS = true;
      
                    }
                   
                      this.testService.shareTestSteps(this.testStep);
                      setTimeout(() => {
                      // this.testService.setStepForEdit(this.testStep[lastIndex])
                    }, 1000);
                   
                  }
                  )
                return;
              }

              if(this.canvas.currentDropTarget.position == 'BELOW' && this.canvas.currentDropTarget.step.type == 'form-step2' && this.testStep)
              {
                this.addBelow(0,'EDIT',this.data['commandName']);
              }
              else
              {
                this.addRow(this.data['commandName'],this.canvas.currentDropTarget.step.data.id)
              }

            })
         
        }
       if(this.canvas.currentDropTarget.step.data.parentId){
        this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testCaseData/' + this.projectId + '/' + this.testId + '/' + this.canvas.currentDropTarget.step.data.parentId).
          subscribe(
            (data) => {

              this.testStepdata = data;
              this.testStep = this.testStepdata.teststepList;
              this.testStepCopy = JSON.parse(JSON.stringify(this.testStep));
              if(this.data['commandName']=='INVOKETEST'){
                this.toastrService.clear();
                this.toastrService.warning('Can not add Invoke command under HITL');
                this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testCaseData/' + this.projectId + '/' + this.testId + '/' + this.testStepId).
                subscribe(
                  (data) => {
                    this.testStepdata = data;
                    this.testStep = [];
                    this.testStep = this.testStepdata.teststepList;
                    for (let i = 0; i < this.testStep.length; i++) {
                      // this.testStep[i] = {
                      //    stepIndex:''
                      //   }
                      this.testStep[i].stepIndex = i;
                      this.testStep[i].viewS = true;
      
                    }
                   
                      this.testService.shareTestSteps(this.testStep);
                      setTimeout(() => {
                      // this.testService.setStepForEdit(this.testStep[lastIndex])
                    }, 1000);
                   
                  }
                  )
                return;
              }

              if(this.canvas.currentDropTarget.position=="BELOW")
              {
                 this.addBelow(this.canvas.currentDropTarget.step.data.stepIndex+1,'EDIT',this.data['commandName']);
              }
              else if(this.canvas.currentDropTarget.position=="ABOVE")
              {
                  this.addBelow(this.canvas.currentDropTarget.step.data.stepIndex,'EDIT',this.data['commandName']);
              }

            })
         
        // this.testService.editTestCase()
       }
       
      var dropTargetId = this.canvas.currentDropTarget.step.id
      var dropTargetIndex = this.canvas.currentDropTarget.step.data.stepIndex+1;
      var index = this.canvas.flow.steps.map(function (getInd) { return getInd.id; }).indexOf(dropTargetId);

       console.log(index);
      // var stepsArray:any = this.canvas.flow.steps.indexOf((dropTargetId))
      // console.log(stepsArray, 'dropId:-',dropTargetId);
      
      this.data['index'] = dropTargetIndex+1;
    }
    
    else if(this.canvas.currentDropTarget && this.canvas.currentDropTarget.position=='RIGHT' || this.canvas.currentDropTarget.position=='ABOVE' || this.canvas.currentDropTarget.position=='LEFT' ){
      if(this.canvas.currentDropTarget.step.type !== 'nested-flow'){
      this.toastrService.clear();
      this.toastrService.warning('You cannot drop command at this position, Only branch is allowed to drop here');

      this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testCaseData/' + this.projectId + '/' + this.testId + '/' + this.testStepId).
      subscribe(
        (data) => {
          this.testStepdata = data;
          this.testStep = [];
          this.testStep = this.testStepdata.teststepList;
          for (let i = 0; i < this.testStep.length; i++) {
            // this.testStep[i] = {
            //    stepIndex:''
            //   }
            this.testStep[i].stepIndex = i;
            this.testStep[i].viewS = true;

          }
         
            this.testService.shareTestSteps(this.testStep);
       
         
        }
        )
      return;
      }
    }
  
    // this.canvas.flow.steps.forEach((element , i)=>{
    //   if(i>index){
    //     element.data['index'] = i+1
    //   }
     
    // })
    // if(this.data['commandName'] !=='Branch1' && this.data['commandName'] !=='Branch2'){
    //   this.confirmationDialogService.openUpdatePopUp( this.data , 'path', 'test-step', 'Add')
    //   .afterClosed().subscribe(res => {
    //     if (res) {
    //       this.toastrService.clear();
    //       this.toastrService.success('Card '  + ' Added successfully');
    //     }
    //   });
    // }
 
  }
  }, 500);
    // console.log(this.data);
  

    //  this.confirmationDialogService.openUpdatePopUp( this.data , 'path', 'test-step', 'Add')
    //     .afterClosed().subscribe(res => {
    //       if (res) {
    //         this.toastrService.clear();
    //         this.toastrService.success('Card '  + ' Added successfully');
    //       }
    //     });
  }
  rcCategoryList(rcCategoryList: any) {
    throw new Error('Method not implemented.');
  }

  override getDropPositionsForStep(
    step: NgFlowchart.Step | NgFlowchart.Connector
  ): NgFlowchart.DropPosition[] {
    return ['BELOW', 'ABOVE'];
  }

  delete() {
    //recursively delete
    this.destroy(true);
  }
  getStepDetails(data){
    this.stepOptions = data
   this.testService.setStepForEdit(this.stepOptions)
   console.log(this.stepOptions);
   
    
  }
  addBelow(lastIndex, buttonIdentifier, commandName?: string) {
    ////"addBello");
    this.checkAllTestSteps = false;
    const items = this.testStep;
    //  const lastIndex =this.testStep.length;
    ////lastIndex);
    const insert = (arr, index, newItem) => [
      // part of the array before the specified index
      ...arr.slice(0, index),
      // inserted item
      newItem,
      // part of the array after the specified index
      ...arr.slice(index)
    ]
    this.testStepCopy[0] = JSON.parse(JSON.stringify(this.testStep[0]));
    

    if (this.projectType === 'WEB') {
      this.testStepCopy[0].commandName = commandName;
    } else if (this.projectType === 'DESKTOP') {
      this.testStepCopy[0].commandName = 'OPENDESKTOPAPP';
    } else if (this.projectType === 'MOBILE') {
      this.testStepCopy[0].commandName = 'OPENMOBILEAPP';
    } else if (this.projectType === 'MIXED') {
      this.testStepCopy[0].commandName = commandName;
    }
    else if (this.projectType === 'REST') {
      this.testStepCopy[0].commandName = 'REQ_START';
    }
    else if (commandName) {
      this.testStepCopy[0].commandName = commandName;
    }
    else {
      this.testStepCopy[0].commandName = 'OPENBROWSER';
    }
    this.testStepCopy[0].comment = '';
    this.testStepCopy[0].runtimeData = 'false';
    this.testStepCopy[0].elementKey = '';
    this.testStepCopy[0].parameters.settingValue = '';
    this.testStepCopy[0].parameters.isMasked = 'false';
    this.testStepCopy[0].pageName = '';
    this.testStepCopy[0].type = 'AUTOMATIC';
    this.testStepCopy[0].active = 'ENABLE';
    if (this.testCaseType == 'MANUAL') {
      this.testStepCopy[0].type = 'MANUAL';
    }
    const result = insert(items, lastIndex, this.testStepCopy[0])

    ////this.testStep[0]);
    ////"insert", result);
    // [1, 10, 2, 3, 4, 5]
    var testStepAtSelectedIndex = this.testStepCopy[0];
    // ////"fromTestStep",this.testStepAtSelectedIndex);
    // testStepAtSelectedIndex.push(this.testStep);

    ////"Create", this.testStep);
    // this.projectId;
    ////this.projectId);
    ////this.testStepId);
    this.testStepdata.teststepList = result;
    ////"Create", result);
    this.testStepCopy = JSON.parse(JSON.stringify(result));
    this.testCopyFlowChart = JSON.parse(JSON.stringify(result));
    // this.loadFlowchart(result);
    for (let i = 0; i < this.testStepCopy.length; i++) {
      // this.testStep[i] = {
      //    stepIndex:''
      //   }
      this.testStepCopy[i].stepIndex = i;
      this.testCopyFlowChart[i].stepIndex = i;
      ////this.testStep);
      // this.testStepCopy = JSON.parse(JSON.stringify(this.testStep));
      ////this.testStepCopy);


    }
    const createTestStepData = this.testStepdata;
    ////createTestStepData);
    const myObject = createTestStepData[0];
    this.testService.editTestCase(this.projectId, this.testId, createTestStepData).
      subscribe((data) => {
        if (data) {
          ////"upDateData", data);
          this.testStepdata = data;
          this.testStep = this.testStepdata.teststepList;
          if(true){
            for (let i = 0; i < this.testStep.length; i++) {
              // this.testStep[i] = {
              //    stepIndex:''
              //   }
              this.testStep[i].stepIndex = i;
              this.testStep[i].viewS = true;
              ////this.testStep);
              this.visibleIndexForCardTip = this.testStepdata.teststepList.length
              
              
            }
            this.toastrService.clear();
            this.toastrService.success('Card Added successfully under the branch')
            console.log('afterB',this.testStep);
            this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testCaseData/' + this.projectId + '/' + this.testId + '/' + this.testStepId).
            subscribe(
              (data) => {
                this.testStepdata = data;
                this.testStep = [];
                this.testStep = this.testStepdata.teststepList;
                for (let i = 0; i < this.testStep.length; i++) {
                  // this.testStep[i] = {
                  //    stepIndex:''
                  //   }
                  this.testStep[i].stepIndex = i;
                  this.testStep[i].viewS = true;
  
                }
               
                  this.testService.shareTestSteps(this.testStep);
                  setTimeout(() => {
                  // this.testService.setStepForEdit(this.testStep[lastIndex])
                }, 1000);
               
              }
              )
            
            // if(commandName == 'HITL' || commandName == 'Branch1' || commandName == 'Branch1'){
            //   this.createBranch(this.projectId,this.testId)
              // this.dropDataService.buildHITL.subscribe((res) => {
              //   setTimeout(() => {
              //     this.createHITLOnDrop(res,'branch1','branch2');
              //   }, 0)
              // })
              // return;
            //  }
            //  else{
              // this.testService.shareTestSteps(JSON.parse(JSON.stringify(this.testStepdata.teststepList)));
            // this.testCase.getTestSteps().subscribe((res) => {
            //   console.log("goutham12123 : ", res);
            //    var branchData = []
            //   for (let index = 0; index < res.length; index++) {
            //     const element = res[index];
            //     if(element.commandName=='HITL' && element.parameters.settingValue.length>10){
            //       console.log('firstparam' ,element.parameters.settingValue);
            //       var branchIdArray = element.parameters.settingValue.split(",");
            //       console.log('bArray',branchIdArray);
            //       branchIdArray.forEach((element1,i)=> {
            //         branchData.push(this.returnBranchSteps(element1))
            //       });
            //       element.branchData = branchData;
            //     }
                
            //   }
            //   console.log("Ashu123 : ", res);
            //   localStorage.setItem('localData',JSON.stringify(res))
             
            //   var setLocally = JSON.parse(localStorage.getItem('localData'));
        
            //   this.testStep = setLocally;
            //   this.testStepCopy = JSON.parse(JSON.stringify(setLocally));
            //   let flowchartView = { "root": this.convertTableToFlowchart(setLocally)};
            //   console.log("goutham12123 : ", flowchartView);
            //   this.sampleJson = flowchartView;
            //   this.showUpload();
            // })
            //  this.stepOptions = undefined;
            //  this.stepOptions = this.testStep[lastIndex]
            //   // this.stepOptions = stepDataO.data
            //   this.stepOptions.index = lastIndex;
            //   this.stepOptions.projectId = this.projectId;
            //   this.stepOptions.parentId=this.testId ;
            //   this.stepOptions.testStepId = this.testStepId; 
            //   this.objectForEditTestStep = this.stepOptions;
              // this.editEnable(this.objectForEditTestStep,lastIndex)
            // }
          
          }
        }
      });
  }
  addRow(commandName: string, id: any) {
    this.testStepAtSelectedIndex = {
      active: "ENABLE",
      commandName: "",
      comment: "",
      runtimeData: 'false',
      debug: "",
      elementKey: "",
      evaluatedMetaValue: "",
      maskedData: "",
      pageName: "",
      parameters: {
        settingValue: '',
        isMasked: 'false'
      },
      result:
      {
        startTime: '0', endTime: '0', duration: '0.0',
        resultState:
        {

        },
        aggrResultState: {

        },
      },
      runState: "",
      testData: "",
      type: "AUTOMATIC",
    }
    if (this.testCaseType == 'MANUAL') {
      this.testStepAtSelectedIndex.type = 'MANUAL';
    }
    // this.testStepAtSelectedIndex = this.testStep[0];
    ////"formTestStep", this.testStepAtSelectedIndex);
    if (commandName) {
      this.testStepAtSelectedIndex.commandName = commandName;
    }
    else {
      if (this.projectType === 'WEB') {
        this.testStepAtSelectedIndex.commandName = 'OPEN';
      } else if (this.projectType === 'DESKTOP') {
        this.testStepAtSelectedIndex.commandName = 'OPENDESKTOPAPP';
      } else if (this.projectType === 'MOBILE') {
        this.testStepAtSelectedIndex.commandName = 'OPENMOBILEAPP';
      } else if (this.projectType === 'MIXED') {
        this.testStepAtSelectedIndex.commandName = 'OPENBROWSER';
      }
      else if (this.projectType === 'REST') {
        this.testStepAtSelectedIndex.commandName = 'REQ_START';
      }
      else {
        this.testStepAtSelectedIndex.commandName = 'OPENBROWSER';
      }
    }
    // this.arr = testStepUpdateForm.value;


    // this.testStepAtSelectedIndex.commandName = 'OPEN';
    this.testStep = [];
    // this.testStep = this.testStepdata.teststepList;
    const items = this.testStep;
    ////items);
    const insert = (arr, index, newItem) => [
      // part of the array before the specified index
      ...arr.slice(0, index),
      // inserted item
      newItem,
      // part of the array after the specified index
      ...arr.slice(index)
    ]

    const result = insert(items, 0, this.testStepAtSelectedIndex)


    this.testStepdata.teststepList = result;
    ////"Create", result);
    const createTestStepData = this.testStepdata;
    ////createTestStepData);
    this.http.post<any>(this.url + '/HuLoopRest/huloop/' + 'test/editTestCase/' + this.projectId + "/" + this.testId + '/false', createTestStepData).
      subscribe((data) => {
        if (data) {
          ////"upDateData", data);
          this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testCaseData/' + this.projectId + '/' + this.testId + '/' + this.testStepId).
            subscribe(
              (data) => {
                this.testStepdata = data;
                this.testStep = [];
                this.testStep = this.testStepdata.teststepList;
                for (let i = 0; i < this.testStep.length; i++) {
                  // this.testStep[i] = {
                  //    stepIndex:''
                  //   }
                  this.testStep[i].stepIndex = i;
                  this.testStep[i].viewS = true;
  
                }
                this.toastrService.clear();
                this.toastrService.success('Card is successfully added under the branch')
               
                  this.testService.shareTestSteps(this.testStep);
                  setTimeout(() => {
                  // this.testService.setStepForEdit(this.testStep[lastIndex])
                }, 1000);
               
              }
              )
          ////item);
          ////'Updaaateee')
         
          ////authCheck);
          
          console.log('DataAddR', this.testStepdata);
          // teststepList
          
        }
      });
  }

  
  selectStep(check)
  {
    let stepIndex;
    this.currentStepSelected = check;
    this.data['checked'] =  check;
    if(check)
    {
      this.selectedSteps.push(this.data)
    }
    else
    {
      this.selectedSteps.forEach((element, i) => {
        if(element.stepIndex == this.data['stepIndex'])
        {
          // element.checked = true;
          stepIndex = i;
        }
      });
      this.selectedSteps.splice(stepIndex, 1);
    }

    this.testService.setSelectedData(this.selectedSteps)
    console.log(this.selectedSteps);
  }
  deleteSteps(data){
    if(this.projectId!='rc'){

   
    if(data.parentId){
      console.log(data.parentId);
      var branchSteps = data
      var Index = data.stepIndex;
        ////Index + 1);
       var branchName = data.title
       
      this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testCaseData/' + this.projectId + '/' + this.testId + '/' + data.parentId).
          subscribe(
            (data) => {
              this.testService.setSelectedData([]);
              this.dropDataService.selectAllSteps.next(false);
              this.testStepdata = data;
              this.testStep = this.testStepdata.teststepList;
              this.stepsTobeDelete = this.testStep[Index];
              const IndexMsg = Index + 1;
              // this.testStepCopy = JSON.parse(JSON.stringify(this.testStep));
              this.confirmationDialogService.openConfirmDialog('Are you sure you want to delete ' + IndexMsg + ' index Card ?')
              .afterClosed().subscribe(res => {
                if (res) {
                 
                  this.toastrService.clear();
                  this.toastrService.success('Card ' + IndexMsg + ' Deleted successfully');
                  this.initiateDelTestStep = this.testStep;
                  for (var i = 0; i < this.initiateDelTestStep.length; i++) {
              
                    if (this.initiateDelTestStep[i] === this.stepsTobeDelete) {
              
                      this.initiateDelTestStep.splice(i, 1);
                    }
              
                  }
                  ////this.initiateDelTestStep);
              
              
              
                  // this.projectId;
                  // ////this.projectId);
                  // ////this.testStepId);
                  this.testStepdata.teststepList = this.initiateDelTestStep;
                  const updateTestStepData = this.testStepdata;
                  ////updateTestStepData);
                  // const myObject = updateTestStepData[0];
                  // var myFinalObject = _.omit(myObject, ['parentNestedBlock']);
                  // ////myFinalObject);
                  
                  
                  this.http.post<any>(this.url + '/HuLoopRest/huloop/' + 'test/editTestCase/' + this.projectId + "/" + this.testId + '/false', updateTestStepData).
                    subscribe((data) => {
                      if (data) {
                        ////"upDateData", data);
                        this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testCaseData/' + this.projectId + '/' + this.testId + '/' + this.testStepId).
                          subscribe(
                            (data) => {
                              this.testStepdata = data;
                            
                              localStorage.setItem('testStepdata', JSON.stringify(this.testStepdata));
                              // ////this.testStepdata);
                        
                         
                              if (this.testStepdata['teststepList']) {
                                this.testStep = this.testStepdata.teststepList;
                                for (let i = 0; i < this.testStep.length; i++) {
              
                                  this.testStep[i].stepIndex = i;
                                  this.testStep[i].viewS = true;
              
                                }
                                this.testService.shareTestSteps(this.testStep);
                              }
                            }
                          )
              
                      }
                    });
              
                }
              });
              // this.addBelow(this.canvas.currentDropTarget.step.data.stepIndex+1,'EDIT',this.data['commandName'])
            })
      return;
    }
    // this.testStepdata = JSON.parse(localStorage.getItem('testStepdata'));
    this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testCaseData/' + this.projectId + '/' + this.testId + '/' + this.testStepId).
    subscribe(
      (res) => {

        this.testStepdata = res;
        this.testStep = this.testStepdata.teststepList;
      
        // this.testStep = this.testStepdata.teststepList;
        var Index = data.stepIndex;
        ////Index + 1);
        const IndexMsg = Index + 1;
        this.stepsTobeDelete = this.testStep[Index];
        ////'>>', this.stepsTobeDelete);
        if (true) {
          this.confirmationDialogService.openConfirmDialog('Are you sure you want to delete ' + IndexMsg + ' index Card ?')
            .afterClosed().subscribe(res => {
              if (res) {
               
                this.toastrService.clear();
                this.toastrService.success('Card ' + IndexMsg + ' Deleted successfully');
                this.initiateDelTestStep = this.testStep;
                for (var i = 0; i < this.initiateDelTestStep.length; i++) {
            
                  if (this.initiateDelTestStep[i] === this.stepsTobeDelete) {
            
                    this.initiateDelTestStep.splice(i, 1);
                  }
            
                }
                ////this.initiateDelTestStep);
            
            
            
                // this.projectId;
                // ////this.projectId);
                // ////this.testStepId);
                this.testStepdata.teststepList = this.initiateDelTestStep;
                const updateTestStepData = this.testStepdata;
                ////updateTestStepData);
                // const myObject = updateTestStepData[0];
                // var myFinalObject = _.omit(myObject, ['parentNestedBlock']);
                // ////myFinalObject);
                
                
                this.http.post<any>(this.url + '/HuLoopRest/huloop/' + 'test/editTestCase/' + this.projectId + "/" + this.testId + '/false', updateTestStepData).
                  subscribe((data) => {
                    if (data) {
                      ////"upDateData", data);
                      this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testCaseData/' + this.projectId + '/' + this.testId + '/' + this.testStepId).
                        subscribe(
                          (data) => {
                            this.testStepdata = data;
                          
                            localStorage.setItem('testStepdata', JSON.stringify(this.testStepdata));
                            // ////this.testStepdata);
                      
                       
                            if (this.testStepdata['teststepList']) {
                              this.testStep = this.testStepdata.teststepList;
                              for (let i = 0; i < this.testStep.length; i++) {
            
                                this.testStep[i].stepIndex = i;
                                this.testStep[i].viewS = true;
            
                              }
                              this.testService.shareTestSteps(this.testStep);
                            }
                            else{
                              this.testService.shareTestSteps([]);
                            }
                          }
                        )
            
                    }
                  });
            
              }
            });
        }
    
      })
    }
    if(this.projectId=='rc'){
        this.currentRcSteps = JSON.parse(localStorage.getItem('allRcSteps'));
        // this.currentRcSteps.forEach(element => {
        //   element.commandName = element.name;
        //   // delete element.name
        // });
        this.rcDetails = JSON.parse(localStorage.getItem('rcDetails'))
        var Index = data.stepIndex;
        ////Index + 1);
        const IndexMsg = Index + 1;
        this.stepsTobeDelete = this.currentRcSteps[Index];
        if (true) {
          this.confirmationDialogService.openConfirmDialog('Are you sure you want to delete ' + IndexMsg + ' index Card ?')
            .afterClosed().subscribe(res => {
              if (res) {
               
                this.toastrService.clear();
                this.toastrService.success('Card ' + IndexMsg + ' Deleted successfully');
                this.initiateDelTestStep = this.currentRcSteps;
                for (var i = 0; i < this.initiateDelTestStep.length; i++) {
                //   this.initiateDelTestStep[i].commandName = this.initiateDelTestStep[i].name
                //  delete this.initiateDelTestStep[i].name;
                  if (this.initiateDelTestStep[i] === this.stepsTobeDelete) {
            
                    this.initiateDelTestStep.splice(i, 1);
                  }
            
                }
                ////this.initiateDelTestStep);

                this.updateRc(this.rcDetails.children.componentName,this.rcDetails.children.accessType,this.rcCat,this.initiateDelTestStep,this.rcId)
            
            
                
               
            
              }
            });
        }

    }
      ////this.testStep.length);
  
    }

    updateRc(componentName,accessType,cat,testSteps,id){
      let obj = {
        "id":id,
        "componentName": componentName,
        "accessType": accessType,
        "category": cat,
        "testSteps": testSteps
      }
      console.log("obj : ", obj);
      this.project.updateRC(obj).subscribe((res:any)=>
      {
        this.toastrService.clear();
        this.toastrService.success("Reusable component updated successfully");
        if(res.testSteps){

       
        localStorage.setItem('allRcSteps',JSON.stringify(res.testSteps))
        this.reloadComponent();
        // this.testService.shareTestSteps(res.testSteps);
        
        }

        // this.cancelCreateRC.nativeElement.click();
        // this.getRC()
      })
    
    }
    cutPaste(index) {
      var cutTestStepData = localStorage.getItem('cutTestStepData');
      var sourceId1 = localStorage.getItem('sourceId').toString();
  
  
      this.testService.cutPaste(this.projectId, sourceId1, this.testStepId, index, JSON.parse(cutTestStepData)).subscribe(
        (data) => {
          this.enableCutPaste = false;
          ////data)
          localStorage.removeItem('cutTestStepData');
          localStorage.removeItem('sourceId');
          setTimeout(() => {
            this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testCaseData/' + this.projectId + '/' + this.testId + '/' + this.testStepId).
              subscribe(
                (data) => {
                  this.testService.setSelectedData([]);
                  this.dropDataService.selectAllSteps.next(false);
                  this.testStepdata = data;
                  this.testStep = this.testStepdata.teststepList;
                  if (sourceId1 == this.testStepId) {
                    // let removeArray = this.indexFormArray.value;
                    // for (let i = 0; i < removeArray.length; i++) {
                    //   this.onChange(removeArray[i], false);
                    // }
  
                  }
  
                  for (let i = 0; i < this.testStep.length; i++) {
                    // this.testStep[i] = {
                    //    stepIndex:''
                    //   }
                    this.testStep[i].stepIndex = i;
                    this.testStep[i].viewS = true;
                    ////this.testStep);
                  }
                  this.visibleIndexForCardTip = this.testStep.length
               
  
                  // ////removeArray);
               
                    this.toastrService.clear();
                    this.toastrService.success('Selected Card pasted successfully');
                      this.testService.setCopyEnable(false);
                      this.testService.setCopyEnable(false)
                    this.testService.shareTestSteps(this.testStep);
  
                }
              )
          }, 0);
  
        }
      )
    }

    pasteStep(index) {
      ////this.testStepArray)
      var copiedSteps = localStorage.getItem('copiedTestStep');
      ////);
  
      if (copiedSteps) {
  
        this.testService.pasteSteps(this.projectId, this.testStepId, this.testStepId, index, JSON.parse(copiedSteps)).subscribe(
          (data) => {
            ////data);
            this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testCaseData/' + this.projectId + '/' + this.testId + '/' + this.testStepId).
              subscribe(
                (data) => {
                  this.testService.setSelectedData([]);
                  this.dropDataService.selectAllSteps.next(false);
                  localStorage.removeItem('copiedTestStep');
                  // this.enablePaste = false;
                  // this.enableCopyCheck = false;
                  this.testStepdata = data;
                  this.testStep = this.testStepdata.teststepList;
                  
  
                  for (let i = 0; i < this.testStep.length; i++) {
                    // this.testStep[i] = {
                    //    stepIndex:''
                    //   }
                    this.testStep[i].stepIndex = i;
                    this.testStep[i].viewS = true;
                    ////this.testStep);
                  }
                  this.visibleIndexForCardTip = this.testStep.length
                  // this.loadFlowchart(this.testStep);
  
                  // ////removeArray);
                    this.testService.shareTestSteps(this.testStep);
                    this.testService.setCopyEnable(false);
                    this.testService.setCopyEnable(false)
                    this.toastrService.clear();
                    this.toastrService.success('Selected Card pasted successfully');
  
                 
  
                }
              )
          }
        )
      }
  
    }

    // showCommandName(command, param) {
    //   if (command != 'Set a Variable Value' && param?.length == 0) {
    //     // if (command.length > 10) {
    //     //   command = command.slice(0, 10) + '...'
    //     // }
    //     // return command;
    //     return this.actionsMetaData[command];
    //   }
    //   else if (command == 'Set a Variable Value' && param?.length > 0 && param?.includes('${_')) {
  
    //     param = param?.substring(0 + 4, param.indexOf("("));
    //     var functionName = this.functions.filter((f) => f.method == param)
    //     if (this.actionsMetaData[functionName[0].name]) {
    //       return this.actionsMetaData[functionName[0].name];
    //     } else {
    //       param = param?.substring(0 + 4, param?.indexOf("(")).slice(0, 10) + '...';
    //     }
    //     return param.toUpperCase();
    //   }
    //   else if (command == 'Set a Variable Value' && param?.length > 0 && !param?.includes('${_')) {
    //     return command.toUpperCase();
    //   }
    //   else if (command == 'Set a Variable Value' && param?.length == 0) {
    //     return command.toUpperCase();
    //   }
    //   else {
  
    //     return this.actionsMetaData[command];
    //   }
    // }

    loadActionsMetaData() {
      return this.groupedActionData.forEach(groupedActionItem => {
        groupedActionItem.children.forEach(action => {
          if (action.type == 'action') {
            this.actionsMetaData[action?.children?.name] = action?.name;
            // this.actionsMetaDataCopy[action?.children?.name] = action.name;
          } else if (action.type == 'fun') {
            this.actionsMetaData[action?.function?.name] = action?.name;
            // this.actionsMetaDataCopy[action?.function?.name] = action?.name;
          } else if (action.type == 'sub') {
            this.actionsMetaData[action.subfunction[0]?.children?.name] = action?.name;
            // this.actionsMetaDataCopy[action.subfunction[0].children?.name] = action?.name;
            // action.subfunction[0]
            // action.subfunction.forEach(subfunction => {
            //   this.actionsMetaData[subfunction.children.name] = subfunction.name;
            // });
          }
        });
        this.actionsMetaData['OPEN'] = 'Open Web Browser';
        // this.actionsMetaDataCopy['OPEN'] = 'Open Web Browser';
      });
  
    }
    getCardIcon(action, param) {
      var actionIcon = 'fa fa-chrome';
      if(this.groupedActionData?.length>0){
      this.actions = JSON.parse(localStorage.getItem('actions'));
      this.functions = JSON.parse(localStorage.getItem('functions'));
      
      var action = action;
      var param = param;
      
      this.groupedActionData.forEach((element, i) => {
        element.children.forEach((element1, j) => {
          if (element1.type == 'action' && element1.children.name == action) {
            actionIcon = element.groupIcon;
          }
          if (element1.type == 'fun' && param?.length > 0 && param?.includes('${_') && element1?.function) {
            var findFunction = this.functions?.filter(f => (f.method == param.substring(0 + 4, param.indexOf("("))));
            if (findFunction && element1.function?.name == findFunction[0]?.name) {
              actionIcon = element.groupIcon;
            }
  
          }
          if (element1.type == 'sub' && param?.length > 0 && param?.includes('${_') && element1?.subfunction) {
            var findFunction = this.functions?.filter(f => (f.method == param.substring(0 + 4, param.indexOf("("))));
            if (findFunction && element1?.subfunction[0]?.children.name == findFunction[0]?.name) {
              actionIcon = element.groupIcon;
            }
  
          }
  
        });
      });
    }
      return actionIcon

    }
    ngOnDestroy() {
      // this.subscription.unsubscribe();
      // this.subscription1.unsubscribe();
      // this.subscription2.unsubscribe();
      // this.subscription3.unsubscribe();
  }
  reloadComponent() {
    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    //['/test/flow-chart', 'rc',rc.name ,comp.children.id]
    this.router.navigate(['/test/flow-chart', 'rc',this.rcCat ,this.rcId]);
  }
  ngOnChanges(){
    this.dropDataService.selectAllSteps.subscribe((res)=>
          {
            this.data['checked'] = res;
            this.currentStepSelected = res;
          })
  }
  // ngAfterViewInit(): void {
  //   // this.dropDataService.selectAllSteps.subscribe((res)=>
  //   //   {
  //   //     this.data['checked'] = res;
  //   //     this.currentStepSelected = res;
  //   //   })
  // }
  
}
